/**
 * A directive that increments the scroll limit on the scope, as passed in, when the scroll bar
 * on the container is close to the bottom.
 * @example <div apex-virtual-limit="vm.scrollLimit"><div ng-repeat="i in collection | limitTo : vm.scrollLimit"></div></div>
 * @returns {any} The directive.
 */
export function VirtualLimitDirective() {
    return {
        restrict: "A",
        scope: {
            apexVirtualLimit: "=",
            limitActivationDistance: "=?"
        },
        link: function (scope, el, attrs) {
            const interval = scope.apexVirtualLimit;
            const activationDistance = 50 || scope.limitActivationDistance;

            el.on("scroll", function () {
                // scrollTop cannot be any higher than the height of the offscreen content, since
                // it represents the top of the scrollbar. It will activate at the very bottom of
                // the scroller if the activation distance is 0.
                if (offscreenHeight(el[0]) - activationDistance < el.scrollTop()) {
                    // Scroller is close to the bottom, so increase the limit by the interval.
                    scope.$apply(function () {
                        scope.apexVirtualLimit += interval;
                    });
                }
            });
        }
    }

    function offscreenHeight(el) {
        return el.scrollHeight - el.offsetHeight;
    }
}
